var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from 'react';
import { useReactiveVar } from '@apollo/client';
import { chartConstructVar } from '../cache';
import { commands } from '../operations/commands';
var useColumnSelect = function (dimensionKey) {
    /*
      set up state manager for each DimensinoSeclect component
      ChartBuilder currently consists of, at least, three dimensions:
        X axis(dimension), Line or Bar(measure), breakdown
    */
    // as if [chartConstruct, setChartConstruct] but using ReactiveVar as global state
    var setChartConstruct = commands.setChartConstruct;
    var chartConstruct = useReactiveVar(chartConstructVar);
    var makeDimension = function (value /*event.currentTarget.dataset*/) {
        var _a, _b;
        if (dimensionKey === 'measures') {
            return {
                type: (_b = (_a = value.chart) === null || _a === void 0 ? void 0 : _a.toUpperCase()) !== null && _b !== void 0 ? _b : 'TABLE',
                label: value.key,
                rowId: value.id,
            };
        }
        if (dimensionKey === 'breakdowns') {
            return {
                label: value.key,
                breakdownId: value.id,
            };
        }
        // dimensionKey === 'dimensions'
        return {
            label: value.key,
            columnId: value.id,
        };
    };
    var onDimensionChange = useCallback(function (event, values, reason) {
        var _a, _b;
        if (!dimensionKey)
            throw new Error('Dimension Key missing. Cannot tell which data structure to update.');
        var isUpdate = chartConstruct && dimensionKey in chartConstruct;
        var edittingDimension = chartConstruct && dimensionKey in chartConstruct ? chartConstruct[dimensionKey] : null;
        var initialUpdate = !isUpdate && (_a = {},
            _a[dimensionKey] = values.map(function (value) {
                return makeDimension(value);
            }),
            _a);
        var update = isUpdate && (_b = {},
            _b[dimensionKey] = reason === 'select'
                ? // case from DimensionSelect Component
                    values.flatMap(function (value /*event.currentTarget.dataset*/) {
                        var newDimensions;
                        if (dimensionKey === 'measures') {
                            // if all measures exists, reset event triggered one
                            newDimensions = edittingDimension.map(function (dimension) {
                                if (dimension.type === value.chart.toUpperCase()) {
                                    return makeDimension(value);
                                }
                                return dimension;
                            });
                            if (!edittingDimension.some(function (dimension) { return dimension.type === value.chart.toUpperCase(); }))
                                newDimensions.push(makeDimension(value));
                        }
                        else {
                            newDimensions = [makeDimension(value)];
                        }
                        return newDimensions;
                    })
                : // case from DimensionChips Component
                    values.map(function (value) {
                        var dimension = edittingDimension.find(function (dimension) { return dimension.label === value.key; });
                        if (dimension)
                            return dimension;
                        return makeDimension(value);
                    }),
            _b);
        setChartConstruct(__assign(__assign(__assign({}, chartConstruct), initialUpdate), update));
    }, [chartConstruct]);
    var onCustomFormulaChange = useCallback(function (event, selectType) {
        var target = event.currentTarget;
        setChartConstruct(__assign(__assign({}, chartConstruct), { measures: chartConstruct === null || chartConstruct === void 0 ? void 0 : chartConstruct.measures.map(function (dataset) {
                var _a;
                if (dataset.label === event.target.name) {
                    var key = selectType === 'customformula' ? 'customFormulaType' : 'denominatorColumnId';
                    Object.assign(dataset, (_a = {},
                        _a[key] = target.dataset[selectType].toUpperCase(),
                        _a));
                }
                return dataset;
            }) }));
    }, [chartConstruct === null || chartConstruct === void 0 ? void 0 : chartConstruct.measures]);
    return { onDimensionChange: onDimensionChange, onCustomFormulaChange: onCustomFormulaChange };
};
export default useColumnSelect;
